module.exports = __webpack_public_path__ + "img/ModularWallV6.e354834e.jpg";